import styled from '@mui/system/styled';
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import IconButton from '@mui/material/IconButton'
export const CustomeCard = styled(Card)({
    // maxWidth: "250px",
    width: "100%",
    // width: "260px",
    height: "380px",
    position: 'relative',
    margin: 'auto',
    '@media (min-width:768px) and (max-width:912px)': {
      // maxWidth: "230px",
      // width: "230px",
      width: "100%",
      height: "460px",
      position: 'relative',
      margin: 'auto'
  
    },
    '@media (min-width:913px) ': {
      // maxWidth: "230px",
      // width: "230px",
      width: "100%",
      height: "450px",
      position: 'relative',
      margin: 'auto'
    }
  })
export const CustomeCardMedia = styled(CardMedia)({
    width: "100% !important",
  
    // height: "256px !important",
    height: "150px !important",
    objectFit: " contain !important",
  
    '@media (min-width:768px) and (max-width:912px)': {
      width: "100% !important",
  
      height: "256px !important",
      objectFit: " cover !important",
    },
    '@media (min-width:913px) ': {
  
  
      width: "100% !important",
  
      height: "256px !important",
      objectFit: " cover !important",
    }
  })
export const CustomeCardActions = styled(CardActions)(({ locale }) => ({
  
    gap: "0rem",
    justifyContent: "space-between",
    padding: "0px ",
    flexDirection: "column",
    marginLeft: "0 !important",
    marginRight: "0 !important",
    alignItems: locale == "ar" ? "flex-start" : "flex-start",
    "&.MuiCardActions-root>:not(:first-of-type)": {
      marginLeft: "0 !important",
      marginRight: "0 !important",
    },
    '@media (min-width:768px) and (max-width:912px)': {
  
      gap: "2rem",
      justifyContent: "space-around",
      padding: "0px"
      ,
      "&.MuiCardActions-root>:not(:first-of-type)": {
        marginLeft: "0 !important",
        marginRight: "0 !important",
      }
  
      ,
  
    },
    '@media (min-width:913px) ': {
  
      gap: "0rem",
      justifyContent: "space-around",
      padding: "0px 0px 16px 0px",
  
  
    },
  }))
export const CustomeCardContent = styled(CardContent)({
    padding: "5px 8px",
    '& .MuiTypography-root':
      { color: "black" },
    '@media (min-width:768px) and (max-width:912px)': {
  
      '& .MuiCardContent-root': {
  
        padding: "16px"
  
      },
    },
    '@media (min-width:913px) ': {
      padding: "5px 8px",
    }
  
  })
export const CustomeIconbtn = styled(IconButton)({
    "&.MuiIconButton-root:hover": {
      backgroundColor: "transparent !important"
    },
    width: "100% ",
    borderRadius: "0% !important",
});